export default "__VITE_ASSET__3d846e02__"